import { RequiredNFTProps } from "../../campaign-requirements-types";
import { getNFTRecommendedByCollectionKey } from "@/services/nft/nft";
import useFetch from "@/hook/useFetch/useFetch";
import TPremiaCard from "@/components/t-premia-card/t-premia-card";
import { BorderlessButton, ContentRequirementsStyled, DescriptionRequirementsStyled, TitleRequirementsStyled } from "./style-components";
import { useUserContext } from "@/contexts/user/useUserContext";
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Mission } from "@/types/mission/mission-type";
import CardRequiredNFT from "@/components/card-required-nft/card-required-nft";
import IconLockLight from "@/assets/icons/lock-light/lock-light.svg";
import IconLockDark from "@/assets/icons/lock-dark/lock-dark.svg";
import { useTheme } from "@/contexts/theme-context/useThemeContext";
import { useGetNFT } from "@/hook/useGetNFT/useGetNFT";
import DOMPurify from 'dompurify';

interface MissionRecommendedInterface {
  missions: Mission[]
}

const RequiredNFT: React.FC<RequiredNFTProps> = ({ collectionKey, objective, setArrayCompletedRequirements, position }) => {
  const { user } = useUserContext();
  const { isDark } = useTheme();
  const navigate = useNavigate();
  const { nft, loading, isOwner } = useGetNFT(collectionKey, user?.main_key ?? null);
  const { loading: loadingRecommended, data: missionRecommended } = useFetch<MissionRecommendedInterface, object>(getNFTRecommendedByCollectionKey, { collection_key: collectionKey }, { autoFetch: Boolean(collectionKey) });
  const idCampaign = missionRecommended?.missions?.[0]?.campaign_id;

  const handleGo = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (idCampaign) {
      navigate(`/campaign/${idCampaign}`);
    }
  }, [navigate, idCampaign]);

  useEffect(() => {
    setArrayCompletedRequirements((prev) => {
      const newArray = [...prev];
      newArray[position] = isOwner;
      return newArray;
    });
  }, [isOwner, setArrayCompletedRequirements, position]);

  return (
    <TPremiaCard variant="dark" style={{ padding: '0px', boxSizing: 'border-box' }}>
      <ContentRequirementsStyled>
        <div style={{ alignSelf: 'stretch', display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <img width={"48px"} height={"48px"} src={isDark ? IconLockDark : IconLockLight} alt="lock" />
          <TitleRequirementsStyled>Requisitos</TitleRequirementsStyled>
          <DescriptionRequirementsStyled dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(objective?.description ?? '') }} />
        </div>
        <CardRequiredNFT
          thumb_url={nft?.[0]?.thumb_url ?? "ImgDefault"}
          name={nft?.[0]?.metadata?.json_data?.name ?? ''}
          token_id={nft?.[0]?.token_id}
          loading={loading}
        >
          {isOwner === true ? (
            <p >
              Ya tienes este coleccionable
            </p>
          ) : (
            <div>
              <BorderlessButton
                type="primary"
                onClick={handleGo}
                loading={loading || loadingRecommended}
              >¡Obtenlo ahora!</BorderlessButton>
            </div>
          )}
        </CardRequiredNFT>
      </ContentRequirementsStyled>
    </TPremiaCard>
  )
}

export default RequiredNFT;